"use client";

import { Fragment } from "react";
import { SERVERS } from "@/lib/servers";
import Reveal from "../Reveal";
import Glow from "../Glow";
import { useLiveStatus } from "../LiveCounts";

export default function Stats() {
  // Total online players = sum of each server's live count, falling back to 0
  // when no live data is available. Server count is the list length.
  const live = useLiveStatus();
  const players = SERVERS.reduce(
    (sum, s) => sum + (live?.[s.slug]?.online ?? 0),
    0,
  );
  const STATS = [
    { value: String(players), label: "Aktive Spieler" },
    { value: String(SERVERS.length), label: "Server" },
    { value: "24/7", label: "Online" },
  ];

  return (
    <section className="relative overflow-hidden py-20 md:py-24">
      {/* Figma glow ellipse 900×300 centered at the bottom edge. */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 mx-auto max-w-page"
      >
        <Glow left="50%" top="100%" width="62.5%" ratio="900 / 300" />
      </div>

      <div className="relative mx-auto flex max-w-page flex-wrap items-center justify-center gap-x-10 gap-y-8 section-pad md:gap-x-20">
        {STATS.map((s, i) => (
          <Fragment key={s.label}>
            {i > 0 && (
              <span
                aria-hidden
                className="hidden h-14 w-px bg-surface-border sm:block md:h-16"
              />
            )}
            <Reveal variant="scale" delay={i * 0.12} className="text-center">
              <div className="gradient-text font-display text-5xl font-extrabold tracking-tight md:text-6xl">
                {s.value}
              </div>
              <div className="mt-3 text-xs uppercase tracking-[0.18em] text-gray-400 md:text-sm">
                {s.label}
              </div>
            </Reveal>
          </Fragment>
        ))}
      </div>
    </section>
  );
}
